import axios from "axios";

/**
 * Consulta los datos del tablero de soportes históricos
 * @param {Object} data - Datos de búsqueda
 * @returns {Promise<Array>} Lista de registros obtenidos
 */

export async function getOrdenEnd(data) {
  try {
    const response = await axios.get(
      "/ProcesosP/DatosCalculados/GetOrderEnd?dato=" + data,
    );
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function getSecuenciaDato(data) {
  try {
    const response = await axios.get(
      "/ProcesosP/DatosCalculados/GetSecuenciaDato?dato=" + data,
    );
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function getDatosCalculados(data) {
  try {
    const response = await axios.post(
      "/ProcesosP/DatosCalculados/Get",
      data,
    );
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function upsertDatosCalculados(data) {
  try {
    const response = await axios.post(
      "/ProcesosP/DatosCalculados/Post",
      data,
    );
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}
